import * as yup from "yup";

export const promoSchema = yup.object().shape({
  promo: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Promo is required"),
});
